'use client';

import {Table} from '@tanstack/react-table';
import React from 'react';
import {TableRowSelection} from '../useTableRowSelection';

export interface TableContextProps<T> {
	table: Table<T>;
	offsetTop: number;
}

export const TableContext = React.createContext<TableContextProps<any> | null>(null);

export const TableSelectionContext = React.createContext<TableRowSelection<any, any> | null>(null);
